import axios from "axios";
import TokenService from "./token-service";
var api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true,
});
api.interceptors.request.use(function (config) {
    var token = TokenService.getAccessToken();
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
}, function (error) { return Promise.reject(error); });
export default api;
